import React from 'react';
import { MessageSquare } from 'lucide-react';
import CaseMessages from '../CaseMessages';

const MessagesSection = ({ caseId }) => {
  return (
    <div>
      <div className="flex items-center gap-2 mb-3">
        <MessageSquare className="h-5 w-5 text-violet-500" />
        <h5 className="font-semibold">Messages</h5>
      </div>
      <CaseMessages caseId={caseId} />
    </div>
  );
};

export default MessagesSection;
